module.exports = "/assets/data/915d37ee3b4ec7d109db44c65ced692c-N13.data.json";